import {
  getExternalCalendarEvent as _getExternalCalendarEvent,
  GetExternalCalendarEventPayload,
} from '@griply/services';
import { CalendarEventDetails } from '@griply/types';
import { httpsCallable } from 'firebase/functions';
import { getErrorReporter } from 'shared/services/error-tracking';

import { getFunctions } from './helpers';

export const getExternalCalendarEvent = async (
  payload: GetExternalCalendarEventPayload,
): Promise<CalendarEventDetails | null> => {
  try {
    return await _getExternalCalendarEvent({
      functions: getFunctions(),
      httpsCallable,
      payload,
    });
  } catch (error: unknown) {
    getErrorReporter().captureException(error, {
      tags: { source: 'external-calendars-get-event' },
    });
    throw error;
  }
};
